Bingo.RegistrationDataFormVerifications = {};

Bingo.RegistrationDataFormVerifications.init = () => {
    Bingo.RegistrationDataFormVerifications.usernameInput = $('.js-registrationDataForm__usernameInput');
    Bingo.RegistrationDataFormVerifications.usernameVerificationDiv = $('.js-registrationDataForm__usernameVerification');
    Bingo.RegistrationDataFormVerifications.usernameVerifiedIcon = $('.js-registrationDataForm__usernameVerifiedIcon');
    Bingo.RegistrationDataFormVerifications.usernameUnverifiedIcon = $('.js-registrationDataForm__usernameUnverifiedIcon');
    Bingo.RegistrationDataFormVerifications.usernameUnverifiedTooltip = $('.js-registrationDataForm__usernameUnverifiedTooltip');
    Bingo.RegistrationDataFormVerifications.usernameDefaultValue = Bingo.RegistrationDataFormVerifications.usernameInput.val();
    Bingo.RegistrationDataFormVerifications.usernameDefaultState = Bingo.RegistrationDataFormVerifications.usernameVerificationDiv.data('default-verified');

    Bingo.RegistrationDataFormVerifications.phoneInput = $('.js-registrationDataForm__phoneInput');
    Bingo.RegistrationDataFormVerifications.phoneVerificationDiv = $('.js-registrationDataForm__phoneVerification');
    Bingo.RegistrationDataFormVerifications.phoneVerifiedIcon = $('.js-registrationDataForm__phoneVerifiedIcon');
    Bingo.RegistrationDataFormVerifications.phoneUnverifiedIcon = $('.js-registrationDataForm__phoneUnverifiedIcon');
    Bingo.RegistrationDataFormVerifications.phoneUnverifiedTooltip = $('.js-registrationDataForm__phoneUnverifiedTooltip');
    Bingo.RegistrationDataFormVerifications.phoneDefaultValue = Bingo.RegistrationDataFormVerifications.phoneInput.val();
    Bingo.RegistrationDataFormVerifications.phoneDefaultState = Bingo.RegistrationDataFormVerifications.phoneVerificationDiv.data('default-verified');

    Bingo.RegistrationDataFormVerifications.verifyUsername();
    Bingo.RegistrationDataFormVerifications.usernameInput.on('input', () => {
        Bingo.RegistrationDataFormVerifications.verifyUsername();
    });

    Bingo.RegistrationDataFormVerifications.verifyPhone();
    Bingo.RegistrationDataFormVerifications.phoneInput.on('input', () => {
        Bingo.RegistrationDataFormVerifications.verifyPhone();
    });
};

Bingo.RegistrationDataFormVerifications.verifyUsername = () => {
    const currentValue = Bingo.RegistrationDataFormVerifications.usernameInput.val();
    if (Bingo.RegistrationDataFormVerifications.usernameDefaultValue !== currentValue
        || (Bingo.RegistrationDataFormVerifications.usernameDefaultValue === currentValue && Bingo.RegistrationDataFormVerifications.usernameDefaultState === false)) {
        Bingo.RegistrationDataFormVerifications.usernameVerifiedIcon.hide();
        Bingo.RegistrationDataFormVerifications.usernameUnverifiedIcon.show();
        Bingo.RegistrationDataFormVerifications.usernameUnverifiedTooltip.show();
    } else {
        Bingo.RegistrationDataFormVerifications.usernameVerifiedIcon.show();
        Bingo.RegistrationDataFormVerifications.usernameUnverifiedIcon.hide();
        Bingo.RegistrationDataFormVerifications.usernameUnverifiedTooltip.hide();
    }
};

Bingo.RegistrationDataFormVerifications.verifyPhone = () => {
    const currentValue = Bingo.RegistrationDataFormVerifications.phoneInput.val();
    if (currentValue !== '') {
        if (Bingo.RegistrationDataFormVerifications.phoneDefaultValue !== currentValue
            || (Bingo.RegistrationDataFormVerifications.phoneDefaultValue === currentValue && Bingo.RegistrationDataFormVerifications.phoneDefaultState === false)) {
            Bingo.RegistrationDataFormVerifications.phoneVerifiedIcon.hide();
            Bingo.RegistrationDataFormVerifications.phoneUnverifiedIcon.show();
            Bingo.RegistrationDataFormVerifications.phoneUnverifiedTooltip.show();
        } else {
            Bingo.RegistrationDataFormVerifications.phoneVerifiedIcon.show();
            Bingo.RegistrationDataFormVerifications.phoneUnverifiedIcon.hide();
            Bingo.RegistrationDataFormVerifications.phoneUnverifiedTooltip.hide();
        }
    } else {
        Bingo.RegistrationDataFormVerifications.phoneVerifiedIcon.hide();
        Bingo.RegistrationDataFormVerifications.phoneUnverifiedIcon.hide();
        Bingo.RegistrationDataFormVerifications.phoneUnverifiedTooltip.hide();
    }
};
